import React, { ReactNode, type FC } from "react";
import { CardActionArea, CardActions, CardContent, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

import { CardStyled } from "./CardAction.styled";

import { CustomColors } from "@type/CustomPalette";
import { Box, Button, Typography } from "@components/base";

interface CardAction {
  button: {
    text: string;
    href?: string;
    onClick?: () => void;
  };
  title: string;
  text: string | ReactNode;
  color: CustomColors;
  icon: "data-gathering" | "databases" | "finances" | "data-cloud" | "computer";
}

const CardAction: FC<CardAction> = ({ button, title, text, color, icon }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleCardClick = (): void => {
    if (button.onClick) {
      button.onClick();
    } else if (button.href) {
      navigate(button.href);
    }
  };

  return (
    <CardStyled
      sx={{
        background: theme.palette.custom[color][50],
        ":hover": {
          background: theme.palette.custom[color][100],
        },
      }}
    >
      <CardActionArea onClick={handleCardClick}>
        <CardContent>
          <Typography variant="subtitle1" gutterBottom>
            {title}
          </Typography>
          {typeof text === "string" ? (
            <Typography sx={{ maxWidth: "650px", pb: 1 }} color="#00000080">
              {text}
            </Typography>
          ) : (
            text
          )}
          <Box sx={{ width: "100%", textAlign: "center" }}>
            <img
              src={`/static/cards/${icon}-${color}.svg`}
              width={160}
              height={160}
              alt={icon}
            />
          </Box>
        </CardContent>
        <CardActions>
          <Button href={button.href} component={Link} size="large">
            {button.text}
          </Button>
        </CardActions>
      </CardActionArea>
    </CardStyled>
  );
};

export default CardAction;
